import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Loading from 'components/Loading';

import Teams from 'pages/Teams';
import DashboardPage from 'pages/Dashboard';

import InvitationsRequest from 'pages/InvitationsRequest';

import { useCurrentUserContext } from 'utils/User';
import { CurrentInvitationContext } from 'utils/Invitation';

import ROUTE_NAMES from 'setup/Routing/routeNames';
import useSentinelTeam from 'hooks/useSentinelTeam';
import Management from 'pages/Management';
import SentinelRoute from '../SentinelRoute';
import SuperUserRoute from '../SuperUserRoute';
import InvitationRoute from '../InvitationRoute';
import ManagerRoute from '../ManagerRoute';

export default function RootPathRoute() {
  const { authenticationKey } = useContext(CurrentInvitationContext);
  const {
    isSuperUser,
    id: userId,
    isManager,
    managedSentinelTeams,
  } = useCurrentUserContext();
  const { hasSentinelTeam } = useSentinelTeam();

  const location = useLocation();

  /* istanbul ignore next -- @preserve */
  if (!userId && !authenticationKey) return <Loading />;

  /* istanbul ignore next -- @preserve */
  if (authenticationKey) {
    return (
      <InvitationRoute>
        <InvitationsRequest />
      </InvitationRoute>
    );
  }

  if (isSuperUser && !hasSentinelTeam) {
    return (
      <SuperUserRoute>
        <Teams />
      </SuperUserRoute>
    );
  }

  const managesMultipleTeams = managedSentinelTeams?.length > 1;
  /* istanbul ignore next -- @preserve */
  if (!hasSentinelTeam && (isManager || managesMultipleTeams)) {
    return (
      <ManagerRoute>
        <Management />
      </ManagerRoute>
    );
  }

  /* istanbul ignore next -- @preserve */
  if (hasSentinelTeam) {
    return (
      <SentinelRoute>
        <DashboardPage />
      </SentinelRoute>
    );
  }

  /* istanbul ignore next -- @preserve */
  return (
    <Navigate
      to={ROUTE_NAMES.access_denied}
      state={{ from: location }}
      replace
    />
  );
}
